// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__23MWv","title":"BackImages_title__XT1eW","images":"BackImages_images__2DIbR"};